import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const ReportTableFilter = (props) => {
    const { columnDef = [], data } = props
    return (
        <TableContainer
            sx={{
                border: '1px solid #00000033',
                borderRadius: '4px',
                overflow: 'hidden',
            }}

        >
            <Table
                className='tableCommomSection'
                sx={{
                    width: '100%',
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                    '& thead th': {
                        borderBottom: '1px solid #00000033',
                        borderRight: '1px solid #00000033 !important',

                    },
                    '& tbody td': {
                        borderBottom: '1px solid #00000033',
                        borderRight: '1px solid #00000033 !important',
                    },
                    '& tbody tr:last-child td': {
                        borderBottom: 'none',
                    },
                    '& thead th:last-child, & tbody td:last-child': {
                        borderRight: 'none !important',
                    },
                }}
            >
                <TableHead>
                    <TableRow>
                        {columnDef.map((col, index) => (
                            <TableCell
                                key={`reportFilter-${col.header}-${col.dataKey}-${index}`}
                                sx={{
                                    ...col.headerSx,
                                    fontWeight: 600,
                                    fontStyle: 'normal',
                                    lineHeight: '16px',
                                    fontSize: '12px',
                                    letterSpacing: '2%',
                                    color: '#000000',
                                    backgroundColor: '#CCE7FF',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {col.header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {columnDef.map((col, colIndex) => (
                            <TableCell
                                key={`dataRow-${col.dataKey}-reportfilterdata-${colIndex}`}
                                sx={{
                                    ...col.headerSx,
                                    fontFamily: 'Roboto',
                                    fontWeight: 500,
                                    fontStyle: 'normal',
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    letterSpacing: '2%',
                                    color: '#202020',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                {data?.[col.dataKey] ?? ''}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default ReportTableFilter